import { format } from 'date-fns'
import { assetDefinitionListingAction } from '../Components/AssetTypeDefinition/AssetTypeDefinationHelper'
import { JOB_TYPE_DISPLAY_VALUES } from '../Components/BulkUpdate/BulkOperationsExport'
import getJobStatus, {
  bulkUpdateListingAction,
  getBulkUpdateListPath,
} from '../Components/BulkUpdate/BulkUpdateHelper'
import { manageFilesListingAction } from '../Components/ManageFiles/ManageFilesHelper'
import commonListingEditBtn from '../Components/Shared/Badges/Edit'
import commonListingReportActionBtn from '../Components/Shared/Badges/ReportAction'
import getStatus from '../Components/Shared/Badges/Status/Index'
import CONSTANTS from '../Constants'
import {
  API_CONFIG,
  API_LIST,
  ENTITLEMENT_CONTROL_POLICY_CRUD,
  LANGUAGE_CONTROL_POLICY_CRUD,
} from '../Constants/ApiDefinations'
import { CONFIG } from '../Constants/Constant/Configs'
import { MANAGE_POLICY_CONSTANTS } from '../Constants/ManagePolicy'
import { PAGE_URL, PageNames } from '../Constants/PagesRoutes/PageURLs'
import {
  AssetDefinationListResponseModal,
  AttributeRepoListResponseModal,
  GeoPolicyListResponseModal,
  ListAPIDefinationModal,
  MasterListResponseModal,
  MasterSysConfigListResponseModal,
  RoleListResponseModal,
  UserListResponseModal,
} from '../Models/CommonListing'
import mainApiService from '../Services'
import { showAlert } from '../Store/Slice/alert.slice'
import { updateAssetTypeService } from '../Store/Slice/asset-definition.slice'
import { fetchMasterData } from '../Store/Slice/master-data.slice'
import { clearSystemConfigurationStore } from '../Store/Slice/system-configuration.slice'
import { setMastersList } from '../Store/Slice/systemConfigurations.slice'
import { secondsToHMS } from './DurationHelper'
import {
  combineErrorMessage,
  getDataBasedOnkey,
  getDateInFormat,
  getFileTypeName,
  mapAllowedMasters,
  notNullUndefined,
  objectToQueryString,
  parseMasterData,
} from './Util'

export const debounce = <T extends (...args: any[]) => void>(func: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout>

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay) // Ensure that the return type matches the function type
  }
}

const getFilterParams = (key: string, filters: any) => {
  let queryPramas: any = {
    limit: filters.limit,
    page: filters.pageNumber,
  }
  switch (key) {
    case 'role':
      queryPramas = {
        ...queryPramas,
        sortType: -1,
      }
      if (filters.search) {
        queryPramas.filterBy = 'roleName'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      }
      break
    case 'user':
      if (filters.search) {
        queryPramas.filterBy = 'userName'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      }
      break
    case 'partner':
      if (filters.search) {
        queryPramas.filterBy = 'serviceName'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      }

      break
    case 'bulkUpdate':
      if (filters.search) {
        queryPramas.filterBy = 'jobName'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      } else if (filters?.filters) {
        queryPramas.filterBy = filters?.filters[0]?.filterBy
        queryPramas.filterCondition = filters?.filters[0]?.filterCondition
        queryPramas.filterValue = filters?.filters[0]?.filterValue
      }
      break
    case 'attributeRepo':
    case 'assetDefination':
      queryPramas = {
        ...queryPramas,
        sortBy: 'createdAt',
        sortType: -1,
      }
      if (filters.search) {
        queryPramas.searchText = filters.search
      }
      break
    case 'geoPolicy':
      if (filters.search) {
        queryPramas.filterBy = 'policyName'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      }
      break
    case 'contentIngestionReport':
      queryPramas = {
        ...queryPramas,
        sortBy: 'createdAt',
        sortType: -1,
      }
      if (filters.search) {
        queryPramas.filterBy = 'requestId'
        queryPramas.filterCondition = 'contains'
        queryPramas.filterValue = filters.search
      }
      break
    default:
      break
  }
  if (filters.sort) {
    queryPramas.sortBy = filters.sort
    queryPramas.sortType = filters.sortType
  }
  return queryPramas
}

const getDaysFromKey = (days: any) => {
  return days
    .map((item: any) => {
      const daydata: any = MANAGE_POLICY_CONSTANTS.DAY_OPTIONS.find(
        (day: any) => day.value === item,
      )
      return daydata?.key
    })
    .join(', ')
}

const getCountriesFromKey = (countryList: any, countries: any) => {
  if (countryList?.length) {
    return countries.map((item: any) => getDataBasedOnkey(countryList, 'value', item)).join(', ')
  } else {
    return ''
  }
}

/**
 *
 * @param pageKey page key string
 * @param savedFilterData saved filter
 * @returns
 * If key is from associated save all filters
 */
const clearOtherFiltersIfSelectedIsModule = (pageKey: string, savedFilterData: any) => {
  if (pageKey.includes('/associated-assets_')) {
    // check associated
    delete savedFilterData['/audit-trails']
    return savedFilterData
  } else if (pageKey.includes('/audit-trails')) {
    return savedFilterData
  }
  return {}
}

export const clearSavedFiltersByKey = (pageKey: string) => {
  let savedFilterData: any = localStorage.getItem('filterData')
  if (savedFilterData) {
    savedFilterData = JSON.parse(savedFilterData)
    if (savedFilterData[`${pageKey}`]) {
      delete savedFilterData[`${pageKey}`]
      localStorage.setItem('filterData', JSON.stringify(savedFilterData))
    }
  }
}

export const getSavedFilter = (pageKey: string) => {
  let savedFilterData: any = localStorage.getItem('filterData')
  if (savedFilterData) {
    savedFilterData = JSON.parse(savedFilterData)
    if (savedFilterData[`${pageKey}`]) {
      return savedFilterData[`${pageKey}`]
    }
  }
  return false
}

export const setSavedFilter = (pageKey: string, data: any) => {
  let savedFilterData: any = localStorage.getItem('filterData')
  if (savedFilterData) {
    savedFilterData = JSON.parse(savedFilterData)
    savedFilterData = clearOtherFiltersIfSelectedIsModule(pageKey, savedFilterData)
    localStorage.setItem('filterData', JSON.stringify({ ...savedFilterData, [pageKey]: data }))
    return
  }
  localStorage.setItem('filterData', JSON.stringify({ [pageKey]: data }))
}

export const onClickCommonListingRow = (params: {
  key: string
  row: Record<string, string | number | boolean | React.ReactElement | object>
  header?: any
  navigate?: any
  dispatch?: any
}) => {
  let url
  switch (params.key) {
    case '/manage-user':
      url = `/manage-user/view/${params.row._id}`
      break
    case '/manage-role':
      url = `/manage-role/view/${params.row._id}`
      break
    case '/metamaster/attribute-repo':
      url = `/metamaster/attribute-repo/view/${params.row._id}`
      break
    case '/metamaster/assets-defination':
      url = `/metamaster/assets-defination/view/${params.row._id}`
      break
    case '/manage-policies/geo-policy':
      url = `/manage-policies/geo-policy/view/${params.row._id}`
      break
    case '/manage-policies/entitlement-control-policy':
      url = `/manage-policies/entitlement-control-policy/view/${params.row._id}`
      break
    case '/manage-policies/language-control-policy':
      url = `/manage-policies/language-control-policy/view/${params.row._id}`
      break
    case '/partners':
      url = `/partners/view/${params.row._id}`
      break
    case PAGE_URL[PageNames.BlukUpdate]:
      url = `${PAGE_URL[PageNames.BlukUpdate]}/view/${params.row.jobId}`
      break
    case PAGE_URL[PageNames.BulkStateChange]:
      url = `${PAGE_URL[PageNames.BulkStateChange]}/view/${params.row.jobId}`
      break
    case PAGE_URL[PageNames.InteractiveBulkUpdate]:
      url = `${PAGE_URL[PageNames.InteractiveBulkUpdate]}/view/${params.row.jobId}`
      break
    case PAGE_URL[PageNames.BulkTranscoding]:
      url = `${PAGE_URL[PageNames.BulkTranscoding]}/view/${params.row.jobId}`
      break
    case '/manage-files':
      url = `/manage-files/view/${params.row.jobId}`
      break
    case '/audit-logs/content-logs':
      url = `/audit-logs/content-logs/view/${params.row._id}`
      break
    case '/audit-logs/user-and-role-logs':
      url = `/audit-logs/user-and-role-logs/view/${params.row._id}`
      break
    case '/audit-logs/master-logs':
      url = `/audit-logs/master-logs/view/${params.row._id}`
      break
    case '/audit-logs/transcoding-logs':
      url = `/audit-logs/transcoding-logs/view/${params.row._id}`
      break
    case '/reports/content-ingestion-report': {
      const {
        blitzContentVersionId = '',
        assetType = '',
        contentCategory = '',
        assetCategory = '',
      } = (params?.row as any) || {}
      url = ''
      if (isIngestionRowClickable(params?.row)) {
        let pageType = CONSTANTS.PAGE_TYPE.VIEW
        let activeVersionId = blitzContentVersionId
        const activeVersion: any = params?.row?.contentData
        if (activeVersion?._id && activeVersion._id !== blitzContentVersionId) {
          activeVersionId = activeVersion._id
          if (activeVersionId?.state === CONSTANTS.ASSET_STATUS.ARCHIEVED) {
            pageType = CONSTANTS.PAGE_TYPE.VIEW_ONLY
          }
        }
        url = `/asset/${pageType}/${activeVersionId}/${assetType}/${contentCategory}/${assetCategory}/${CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY}`
      }
      break
    }
    case '/reports/bulk-operations-report': {
      const { jobType = '' } = (params?.row as any) || {}
      url = ''
      switch (jobType) {
        case CONFIG.BULK_OPS_TYPES.BULK_UPDATE:
          url = `${PAGE_URL[PageNames.BlukUpdate]}/view/${params.row.jobId}`
          break
        case CONFIG.BULK_OPS_TYPES.BULK_STATE_CHANGE:
          url = `${PAGE_URL[PageNames.BulkStateChange]}/view/${params.row.jobId}`
          break
        case CONFIG.BULK_OPS_TYPES.INTERACTIVE_BULK_UPDATE:
          url = `${PAGE_URL[PageNames.InteractiveBulkUpdate]}/view/${params.row.jobId}`
          break
        case CONFIG.BULK_OPS_TYPES.BULK_TRANSCODING:
          url = `${PAGE_URL[PageNames.BulkTranscoding]}/view/${params.row.jobId}`
          break
        default:
          url = ''
          break
      }
      break
    }
    case '/metamaster/manage-tips':
      url = `/metamaster/manage-tips/view/${params.row._id}`
      break
    default:
      break
  }

  if (url && params.navigate) {
    const sanitizedRow = JSON.parse(JSON.stringify(params.row))
    params.navigate(url, { state: { data: sanitizedRow } })
  }
  return url
}

export const isIngestionRowClickable = (data: any = {}) => {
  const isValid = (value: string | undefined) => value && value !== CONSTANTS.DEFAULT_TEXT
  const {
    blitzContentVersionId = '',
    assetType = '',
    contentCategory = '',
    assetCategory = '',
    // requestedObj: { action = '' } = {},
    // blitzContentStatus = '',
  } = data
  return (
    // checkRowClickable(action as string, blitzContentStatus as string) &&
    isValid(blitzContentVersionId) &&
    isValid(assetType) &&
    isValid(contentCategory) &&
    isValid(assetCategory)
  )
}

export const onClickCommonListingBack = (params: { pageConfig: any; navigate: any }) => {
  if (params?.pageConfig?.key?.includes('/metamaster/masters/')) {
    const path = params.pageConfig.key.split('/')
    params.navigate(path.slice(0, path.length - 1).join('/'))
  }
}

export const fetchUserListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args

  const paramsData = objectToQueryString(getFilterParams('user', filters))

  dispatch(setLoader(true))
  const requestedData = API_CONFIG(API_LIST.USER.GET_LIST, {}, null, paramsData)
  const result: any = await mainApiService(requestedData)

  if (result?.responseCode === 200) {
    const tempData: UserListResponseModal[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        userName: ele.userName,
        cyberarkId: ele.cyberarkId,
        userEmail: ele.userEmail,
        roleName: ele.roles?.roleName || 'None',
        createdAt: format(new Date(ele.createdAt.split('T')[0]), 'dd/MM/yyyy'),
        status: getStatus(ele.status === 'ACTIVE'),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchPartnersListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const paramsData = objectToQueryString(getFilterParams('partner', filters))

  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(
    API_LIST.PARTNER_APIS.GET_ALL_PARTNERS,
    null,
    null,
    paramsData,
  )
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        serviceName: ele.serviceName || CONSTANTS.DEFAULT_TEXT,
        serviceAlias: ele.serviceAlias || CONSTANTS.DEFAULT_TEXT,
        contractStartDate: ele.contractStartDate
          ? format(new Date(ele.contractStartDate), CONSTANTS.DATE_FORMAT_TIME)
          : CONSTANTS.DEFAULT_TEXT,
        contractEndDate: ele.contractEndDate
          ? format(new Date(ele.contractEndDate), CONSTANTS.DATE_FORMAT_TIME)
          : CONSTANTS.DEFAULT_TEXT,
        contactEmail: ele.contactEmail || CONSTANTS.DEFAULT_TEXT,
        contactPhone: ele.contactPhone || CONSTANTS.DEFAULT_TEXT,
        allowedAssetTypes: ele?.allowedAssetTypes,
        allowedMasters: mapAllowedMasters(
          ele?.allowedMasters,
          CONSTANTS.STATIC_OPTION_FOR_ALLOWEDMASTER,
        ),
        status: getStatus(ele.status === 'ACTIVE'),
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchBulkUploadListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const payload: any = {
    jobType: pageConfig.pageName,
    limit: filters.limit,
    page: filters.pageNumber,
    jobFilters: [],
  }
  if (filters?.filters || filters?.state) {
    if (filters?.filters) {
      filters?.filters?.forEach((item: any) => {
        payload.jobFilters.push(item)
      })
    }
    if (filters?.state?.length) {
      payload.jobFilters.push({
        filterBy: 'status',
        filterValue: filters?.state.length > 1 ? filters?.state : filters?.state[0],
        filterCondition: filters?.state.length > 1 ? 'in' : 'equals',
      })
    }
  }
  if (filters.search) {
    payload.titleOrId = filters.search
  }
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = Number(filters.sortType)
  }
  dispatch(setLoader(true))
  // const requestedData: any = BULK_OPERATIONS_API.GET_JOB_LIST(payload)
  const requestedData: any = API_CONFIG(API_LIST.BULK_UPLOAD.GET_JOB_LIST, payload, {
    jobType: getBulkUpdateListPath(pageConfig.pageName),
  })
  const result: any = await mainApiService(requestedData)
  // const result = BULK_UPDATE_CONSTENT.LISTING_API_RESPONSE
  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        _id: ele._id,
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        jobId: ele.jobId || CONSTANTS.DEFAULT_TEXT,
        jobName: ele.jobName || CONSTANTS.DEFAULT_TEXT,
        assetCount: ele.assetCount || CONSTANTS.DEFAULT_TEXT,
        userName: ele.userName || CONSTANTS.DEFAULT_TEXT,
        scheduleDate: ele.scheduleDate,
        endDate: ele.endDate,
        successCount: ele.successCount || CONSTANTS.DEFAULT_TEXT,
        failureCount: ele.failureCount || CONSTANTS.DEFAULT_TEXT,
        requestData: ele.requestData || CONSTANTS.DEFAULT_TEXT,
        status: getJobStatus(ele.status),
        action: bulkUpdateListingAction(ele, dispatch),
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchBulkTranscodingListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const payload: any = {
    jobType: pageConfig.pageName,
    limit: filters.limit,
    page: filters.pageNumber,
    jobFilters: [],
  }
  if (filters?.filters || filters?.state) {
    if (filters?.filters) {
      filters?.filters?.forEach((item: any) => {
        payload.jobFilters.push(item)
      })
    }
    if (filters?.state?.length) {
      payload.jobFilters.push({
        filterBy: 'status',
        filterValue: filters?.state.length > 1 ? filters?.state : filters?.state[0],
        filterCondition: filters?.state.length > 1 ? 'in' : 'equals',
      })
    }
  }
  if (filters.search) {
    payload.titleOrId = filters.search
  }
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = Number(filters.sortType)
  }
  dispatch(setLoader(true))
  // const requestedData: any = BULK_OPERATIONS_API.GET_TRANSCODING_JOB_LIST(payload)

  const requestedData: any = API_CONFIG(API_LIST.BULK_APIS.GET_ALL_TRANSCODING, payload)
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        _id: ele._id,
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        jobId: ele.jobId || CONSTANTS.DEFAULT_TEXT,
        jobName: ele.jobName || CONSTANTS.DEFAULT_TEXT,
        fileType: ele?.requestData?.processType === 'INTEGRATED' ? 'Integrated' : 'Non-Integrated',
        assetCount: ele.assetCount || CONSTANTS.DEFAULT_TEXT,
        userName: ele.userName || CONSTANTS.DEFAULT_TEXT,
        scheduleDate: ele.scheduleDate,
        endDate: ele.endDate,
        successCount: ele.successCount || CONSTANTS.DEFAULT_TEXT,
        failureCount: ele.failureCount || CONSTANTS.DEFAULT_TEXT,
        requestData: ele.requestData || CONSTANTS.DEFAULT_TEXT,
        status: getJobStatus(ele.status),
        action: bulkUpdateListingAction(ele, dispatch),
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchBulkOperationsReportsListing = async (
  args: any,
): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const payload: any = {
    limit: filters.limit,
    page: filters.pageNumber,
    sort: 'startTime',
    jobFilters: [],
  }
  if (filters?.filters || filters?.state) {
    if (filters?.filters) {
      filters?.filters?.forEach((item: any) => {
        if (item.filterCondition === 'null') {
          payload.jobFilters.push({ ...item, filterCondition: 'equals', filterValue: null })
        } else if (item.filterCondition === 'notNull') {
          payload.jobFilters.push({ ...item, filterCondition: 'notEquals', filterValue: null })
        } else {
          payload.jobFilters.push(item)
        }
      })
    }
    if (filters?.state?.length) {
      payload.jobFilters.push({
        filterBy: 'status',
        filterValue: filters?.state.length > 1 ? filters?.state : filters?.state[0],
        filterCondition: filters?.state.length > 1 ? 'in' : 'equals',
      })
    }
  }
  if (filters.search) {
    payload.titleOrId = filters.search
  }
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = Number(filters.sortType)
  }
  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(API_LIST.BULK_STATE_CHANGE.GET_REPORT_LIST, payload)
  const result: any = await mainApiService(requestedData)
  // const result = BULK_UPDATE_CONSTENT.LISTING_API_RESPONSE
  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        _id: ele._id,
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        jobId: ele.jobId || CONSTANTS.DEFAULT_TEXT,
        jobName: ele.jobName || CONSTANTS.DEFAULT_TEXT,
        assetCount: ele.assetCount || CONSTANTS.DEFAULT_TEXT,
        userName: ele.userName || CONSTANTS.DEFAULT_TEXT,
        scheduleDate: ele.scheduleDate,
        endDate: ele.endDate,
        successCount: ele.successCount || CONSTANTS.DEFAULT_TEXT,
        failureCount: ele.failureCount || CONSTANTS.DEFAULT_TEXT,
        requestData: ele.requestData || CONSTANTS.DEFAULT_TEXT,
        status: getJobStatus(ele.status),
        action: bulkUpdateListingAction(ele, dispatch, false),
        jobType: JOB_TYPE_DISPLAY_VALUES[ele.jobType] || ele.jobType,
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchPartnerInformation = async (args: any): Promise<ListAPIDefinationModal> => {
  const { dispatch, setLoader, showAlert, pageConfig } = args

  dispatch(setLoader(true))
  const result = {
    responseCode: 200,
    data: {
      count: 1,
      records: [
        {
          _id: '1',
          serviceName: 'Partner Inc.',
          serviceAlias: 'PI',
          contractStartdate: '2023-01-01T00:00:00Z',
          contractEnddate: '2025-01-01T00:00:00Z',
          contactEmail: 'contact@partner.com',
          contactPhone: '123-456-7890',
          status: 'ACTIVE',
        },
      ],
    },
  }

  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        serviceName: ele.serviceName,
        serviceAlias: ele.serviceAlias,
        contactEmail: ele.contactEmail,
        contactPhone: ele.contactPhone,
        contractStartdate: format(new Date(ele.contractStartdate.split('T')[0]), 'dd/MM/yyyy'),
        contractEnddate: format(new Date(ele.contractEnddate.split('T')[0]), 'dd/MM/yyyy'),
        status: getStatus(ele.status),
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchManageFilesListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const payload: any = {
    limit: filters.limit,
    page: filters.pageNumber,
    jobFilters: [],
  }
  if (filters?.filters || filters?.state) {
    if (filters?.filters) {
      filters?.filters?.forEach((item: any) => {
        payload.jobFilters.push(item)
      })
    }
    if (filters?.state?.length) {
      payload.jobFilters.push({
        filterBy: 'status',
        filterValue: filters?.state.length > 1 ? filters?.state : filters?.state[0],
        filterCondition: filters?.state.length > 1 ? 'in' : 'equals',
      })
    }
  }
  if (filters.search) {
    payload.titleOrId = filters.search
  }
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = Number(filters.sortType)
  }
  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(API_LIST.MANAGE_FILE.LIST, payload)
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: any[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        _id: ele._id,
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        jobId: ele.jobId || CONSTANTS.DEFAULT_TEXT,
        jobName: ele.jobName || CONSTANTS.DEFAULT_TEXT,
        jobType: getFileTypeName(ele.jobType) || CONSTANTS.DEFAULT_TEXT,
        count: ele.count || CONSTANTS.DEFAULT_TEXT,
        userName: ele.userName || CONSTANTS.DEFAULT_TEXT,
        startDate: ele.startDate || CONSTANTS.DEFAULT_TEXT,
        status: ele.status || CONSTANTS.DEFAULT_TEXT,
        successCount: ele.successCount || CONSTANTS.DEFAULT_TEXT,
        failureCount: ele.failureCount || CONSTANTS.DEFAULT_TEXT,
        action: manageFilesListingAction(ele, dispatch),
      })
    })

    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchRoleListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args

  const paramsData = objectToQueryString(getFilterParams('role', filters))

  dispatch(setLoader(true))
  const requestedData = API_CONFIG(API_LIST.ROLES.LIST_ROLE, null, null, paramsData)

  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: RoleListResponseModal[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        roleName: ele.roleName,
        associatedUsers: ele.associatedUsers,
        createdAt: getDateInFormat(ele.createdAt as string, 'dd/MM/yyyy'),
        updatedAt: getDateInFormat(ele.updatedAt as string, 'dd/MM/yyyy'),
        status: getStatus(ele?.status === 'ACTIVE'),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchAttributeRepoListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const paramsData = objectToQueryString(getFilterParams('attributeRepo', filters))
  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(
    API_LIST.ATTRIBUTE_REPOSITORY.LIST_ATTRIBUTE_REPO,
    null,
    null,
    paramsData,
  )
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: AttributeRepoListResponseModal[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele?._id,
        label: ele?.label,
        fieldType: ele?.fieldType,
        dataType: ele?.dataType,
        fieldName: ele?.fieldName,
        isRequired: ele?.isRequired ? 'Yes' : 'No',
        isB2B: ele?.isB2B ? 'Yes' : 'No',
        isEMA: ele?.isEMA ? 'Yes' : 'No',
        status: getStatus(ele.status === 'ACTIVE'),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchAssetDefinationListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig, cmsConfig } = args
  const paramsData = objectToQueryString(getFilterParams('assetDefination', filters))
  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(
    API_LIST.ASSET_TYPE_DEFINITION.LIST_ASSET_TYPE,
    null,
    null,
    paramsData,
  )
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: AssetDefinationListResponseModal[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele, dispatch }),
        _id: ele?._id,
        assetType: ele?.assetType,
        assetCategory: ele?.assetCategory,
        contentCategory: ele?.contentCategory,
        haveAllowedParents: ele?.haveAllowedParents ? 'Yes' : 'No',
        status: getStatus(ele.status === 'ACTIVE'),
        action: assetDefinitionListingAction(ele, dispatch, setLoader, cmsConfig),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchGeoPolicyListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const paramsData = objectToQueryString(getFilterParams('geoPolicy', filters))
  dispatch(setLoader(true))
  const masterKeys = ['COUNTRIES']
  const requestedData: any = API_CONFIG(API_LIST.GEO_POLICY.LIST_GEO_POLICY, null, null, paramsData)
  const [result, masterData]: any = await Promise.all([
    mainApiService(requestedData),
    dispatch(fetchMasterData(masterKeys)),
  ])
  const parsedMasters = parseMasterData(masterData, masterKeys)
  if (result?.responseCode === 200) {
    const tempData: GeoPolicyListResponseModal[] = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele?._id,
        policyName: ele?.policyName,
        description: ele?.description,
        timeDifference: secondsToHMS(ele?.timeDifference),
        countries: getCountriesFromKey(parsedMasters?.COUNTRIES, ele?.countries),
        days: getDaysFromKey(ele?.days),
        status: getStatus(ele?.status === 'ACTIVE'),
        geoPolicyGroupName: ele?.geoPolicyGroupName || CONSTANTS.DEFAULT_TEXT,
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchEntitlementControlPolicyListing = async (
  args: any,
): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const paramsData = objectToQueryString(getFilterParams('geoPolicy', filters))
  dispatch(setLoader(true))
  const masterKeys = [
    'AFFILIATEPARTNERS',
    'COUNTRIES',
    'DOWNSTREAMPLATFORMS',
    'ENTITLEMENT',
    'ENTITLEMENT_CHANGE_TYPE',
  ]
  const [result, masterData]: any = await Promise.all([
    mainApiService(ENTITLEMENT_CONTROL_POLICY_CRUD.GET_POLICY_LIST(paramsData)),
    dispatch(fetchMasterData(masterKeys)),
  ])
  const parsedMasters = parseMasterData(masterData, masterKeys)

  if (result?.responseCode === 200) {
    const tempData: any = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele?._id,
        policyName: ele?.policyName,
        applicableEntitlement: ele?.applicableEntitlement,
        entitlementChangeType:
          getCountriesFromKey(parsedMasters?.ENTITLEMENT_CHANGE_TYPE, [
            ele?.entitlementChangeType,
          ]) || CONSTANTS.DEFAULT_TEXT,
        freePreviewDuration: ele?.freePreviewDuration,
        entitlementChangeTimeDifference: notNullUndefined(ele?.entitlementChangeTimeDifference)
          ? secondsToHMS(ele?.entitlementChangeTimeDifference)
          : CONSTANTS.DEFAULT_TEXT,
        applicableCountries: getCountriesFromKey(
          parsedMasters?.COUNTRIES,
          ele?.applicableCountries,
        ),
        applicablePlatforms: getCountriesFromKey(
          parsedMasters?.DOWNSTREAMPLATFORMS,
          ele?.applicablePlatforms,
        ),
        applicablePartners: getCountriesFromKey(
          parsedMasters?.AFFILIATEPARTNERS,
          ele?.applicablePartners,
        ),
        // days: getDaysFromKey(ele?.days),
        status: getStatus(ele?.status === 'ACTIVE'),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchLanguageControlPolicyListing = async (
  args: any,
): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const paramsData = objectToQueryString(getFilterParams('geoPolicy', filters))
  dispatch(setLoader(true))
  const [result]: any = await Promise.all([
    mainApiService(LANGUAGE_CONTROL_POLICY_CRUD.GET_LANGUAGE_POLICY_LIST(paramsData)),
  ])

  if (result?.responseCode === 200) {
    const tempData: any = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        _id: ele?._id,
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        policyName: ele?.policyName,
        status: getStatus(ele?.status === 'ACTIVE'),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchAuditTrailListing = async (args: any) => {
  const { filters, dispatch, setLoader, pageConfig } = args

  const reqData: any = {
    type: pageConfig?.type,
    page: filters?.pageNumber ?? 1,
    limit: filters?.limit ?? 10,
    searchFilters: [],
  }
  if (filters?.filters) {
    const uniqueFilters = Object.values(
      filters?.filters.reduce((acc: any, filter: any) => {
        acc[filter.filterBy] = filter
        return acc
      }, {} as any),
    )
    reqData.searchFilters = [...reqData.searchFilters, ...uniqueFilters]
  }
  if (filters?.fromDate) {
    reqData.fromDate = filters.fromDate
  }

  if (filters?.toDate) {
    reqData.toDate = filters.toDate
  }

  if (filters?.contentId) {
    reqData.contentId = filters.contentId
  }

  if (filters?.addArchivedData) {
    reqData.addArchivedData = filters.addArchivedData
  }

  if (filters?.sortBy) {
    reqData.sortBy = filters.sortBy
    reqData.sortType = filters.sortType
  }

  if (filters?.userName) {
    const userFilter = {
      filterBy: 'userName',
      filterValue: filters.userName,
      filterCondition: 'contains',
    }
    reqData.searchFilters.push(userFilter)
  }

  try {
    dispatch(setLoader(true))
    const requestData: any = API_CONFIG(API_LIST.AUDIT_LOGS.LIST_USER_ROLE_LOG, reqData)

    const response = await mainApiService(requestData)
    const records = response?.data || {}

    if (records?.records) {
      const tempData = getListingForAuditTrailsBasedOnType(records.records, pageConfig)
      dispatch(setLoader(false))
      return {
        count: records?.count,
        records: tempData,
      }
    }
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  } catch (error) {
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}
const capitalizeFirstLetterOfEachWord = (str: string): string => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase())
}

export const fetchMastersListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig, navigate, isWritePermission } = args
  const paramsData = objectToQueryString(getFilterParams('geoPolicy', filters))
  dispatch(setLoader(true))
  dispatch(clearSystemConfigurationStore({}) as any)
  const defaultRequestedData: any = API_CONFIG(
    API_LIST.MASTER_APIS.GET_MASTER_LIST,
    null,
    null,
    `keyName=${pageConfig.pageName}&${paramsData}`,
  )
  const nonDefaultRequestedData: any = API_CONFIG(
    API_LIST.SYSTEM_CONFIGURATION.CONFIG_LIST,
    null,
    null,
    `keyName=${pageConfig.pageName}&${paramsData}`,
  )
  const requestedData = pageConfig.isDefaultMaster ? defaultRequestedData : nonDefaultRequestedData
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    let tempData: MasterListResponseModal[] | MasterSysConfigListResponseModal[] = []
    const recordsList = result?.data?.records || result?.data
    recordsList.forEach((ele: any) => {
      if (pageConfig.isDefaultMaster) {
        tempData = tempData as MasterListResponseModal[]
        tempData.push({
          rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
          ...ele,
          createdBy: ele?.createdBy?.userEmail,
          updatedBy: ele?.updatedBy?.userEmail,
          status: getStatus(ele.status === 'ACTIVE'),
          action: isWritePermission
            ? commonListingEditBtn(dispatch, navigate, ele, `${pageConfig.key}/edit/${ele?._id}`)
            : CONSTANTS.DEFAULT_TEXT,
        })
      } else {
        tempData = tempData as MasterSysConfigListResponseModal[]
        tempData.push({
          rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
          ...ele,
          pageName: pageConfig.pageName,
          url: pageConfig.key,
          name: capitalizeFirstLetterOfEachWord(pageConfig.pageTitle),
          action: isWritePermission
            ? commonListingEditBtn(dispatch, navigate, ele, `${pageConfig.key}/edit/${ele?._id}`)
            : CONSTANTS.DEFAULT_TEXT,
        })
      }
    })
    if (!pageConfig.isDefaultMaster && !tempData.length) {
      dispatch(
        setMastersList([
          {
            pageName: pageConfig.pageName,
            url: pageConfig.key,
            name: capitalizeFirstLetterOfEachWord(pageConfig.pageTitle),
          },
        ]),
      )
    } else {
      dispatch(setMastersList(tempData))
    }
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

const getListingForAuditTrailsBasedOnType = (records: any, pageConfig: any) => {
  const type = pageConfig?.['type']
  const tempData: any[] = []
  if (type === 'content') {
    records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        contentId: ele.assetId,
        event: ele.event,
        contentVersionId: ele?.contentVersionId || CONSTANTS.DEFAULT_TEXT,
        activity: ele.activity,
        assetState:
          ele.assetState === CONSTANTS.ASSET_STATUS.CREATED
            ? CONSTANTS.ASSET_STATE_DISPLAY.CREATED
            : ele.assetState,
        userName: ele.userName,
        roleName: ele.roleName,
        createdAt: getDateInFormat(ele.createdAt as string, CONSTANTS.DATE_FORMAT_TIME_SECONDS),
        updatedAt: getDateInFormat(ele.updatedAt as string, CONSTANTS.DATE_N_TIME_FORMAT_SECONDS),
        blitzTransactionId: ele.blitzTransactionId,
      })
    })
  }

  if (type === 'user_role') {
    records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        subType: ele.subType,
        event: ele.event,
        activity: ele.activity,
        userName: ele.userName,
        roleName: ele.roleName,
        createdAt: getDateInFormat(ele.createdAt as string, CONSTANTS.DATE_FORMAT_TIME_SECONDS),
        updatedAt: getDateInFormat(ele.updatedAt as string, CONSTANTS.DATE_N_TIME_FORMAT_SECONDS),
        blitzTransactionId: ele.blitzTransactionId,
      })
    })
  }

  if (type === 'master') {
    records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        subType: ele.subType,
        event: ele.event,
        activity: ele.activity,
        userName: ele.userName,
        roleName: ele.roleName,
        createdAt: getDateInFormat(ele.createdAt as string, CONSTANTS.DATE_FORMAT_TIME_SECONDS),
        updatedAt: getDateInFormat(ele.updatedAt as string, CONSTANTS.DATE_N_TIME_FORMAT_SECONDS),
        blitzTransactionId: ele.blitzTransactionId,
      })
    })
  }

  if (type === 'transcoding') {
    records?.forEach((ele: any) => {
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: ele }),
        _id: ele._id,
        contentId: ele.assetId,
        event: ele.event,
        userName: ele.userName,
        roleName: ele.roleName,
        createdAt: getDateInFormat(ele.createdAt as string, CONSTANTS.DATE_FORMAT_TIME_SECONDS),
        updatedAt: getDateInFormat(ele.updatedAt as string, CONSTANTS.DATE_N_TIME_FORMAT_SECONDS),
        blitzTransactionId: ele.blitzTransactionId,
      })
    })
  }

  return tempData
}

export const checkIsPartnerParentsFailed = (element: any, rowsData: any) => {
  if (element?.assetCategory === 'GOB' || element?.assetCategory === 'BUNDLE') {
    return false
  }
  const isFailed = rowsData.filter((item: any) => {
    return (
      item.requestId === element.requestId &&
      (item?.assetCategory === 'GOB' || item?.assetCategory === 'BUNDLE') &&
      (item?.blitzContentStatus === 'FAILURE' || item?.blitzContentStatus === 'VALIDATION_FAILED')
    )
  })
  return isFailed.length > 0
}

export const checkIsPartnerContentItemFailed = (element: any) => {
  return (
    (element?.blitzContentStatus === 'SUCCESS' ||
      element?.blitzContentStatus === 'FAILURE' ||
      element?.blitzContentStatus === 'VALIDATION_FAILED') &&
    element?.assetCategory === 'CONTENT_ITEM'
  )
}

export const fetchContentIngestionListing = async (args: any): Promise<any> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args
  const payload: any = {
    limit: filters.limit,
    page: filters.pageNumber,
    inboundFilters: [],
  }
  if (filters?.filters) {
    if (filters?.filters) {
      filters?.filters?.forEach((item: any) => {
        if (item.filterBy === 'blitzContentId') {
          payload.inboundFilters.push({ ...item, filterValue: Number(item.filterValue) })
        } else if (
          item.filterBy === 'partnerRequestTimestamp' &&
          item.filterCondition === 'between'
        ) {
          payload.inboundFilters.push({
            ...item,
            filterValue: item.filterValue,
            filterValueTo: item.filterValueTo,
          })
        } else {
          payload.inboundFilters.push(item)
        }
      })
    }
  }
  if (filters.search) {
    payload.requestId = filters.search
  }
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = Number(filters.sortType)
  }
  const requestedData: any = API_CONFIG(API_LIST.DASHBOARD_API.GET_INJUSTION_REPORT, payload)
  dispatch(setLoader(true))
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const rowsData = (result?.data?.records || result?.data) ?? []
    const tempData: any = []
    rowsData?.forEach((element: any) => {
      const wweFieldsData: any = {
        assetType: element?.assetType ?? CONSTANTS.DEFAULT_TEXT,
        assetCategory: element?.assetCategory ?? CONSTANTS.DEFAULT_TEXT,
        contentCategory: element?.contentCategory ?? 'Sports',
        jobType: element?.jobType ?? CONSTANTS.DEFAULT_TEXT,
        blitzContentVersionId: element?.blitzContentVersionId ?? CONSTANTS.DEFAULT_TEXT,
        blitzContentId: element?.blitzContentId ?? CONSTANTS.DEFAULT_TEXT,
        title: element?.title ?? CONSTANTS.DEFAULT_TEXT,
        contentId: element?.publishedContentId ?? CONSTANTS.DEFAULT_TEXT,
        assetTitle: element?.assetTitle ?? CONSTANTS.DEFAULT_TEXT,
        action: commonListingReportActionBtn(dispatch, element, 'Re-trigger', rowsData),
        blitzContentStatus: element?.blitzContentStatus ?? CONSTANTS.DEFAULT_TEXT,
        isRowClickable: isIngestionRowClickable(element),
      }
      tempData.push({
        rowURL: onClickCommonListingRow({ key: pageConfig.key, row: element }),
        ...element,
        ...wweFieldsData,
        partnerContentId: element?.partnerContentId || CONSTANTS.DEFAULT_TEXT,
        partnerRequestTimestamp: element?.partnerRequestTimestamp
          ? element?.partnerRequestTimestamp
          : CONSTANTS.DEFAULT_TEXT,
        details: commonListingReportActionBtn(dispatch, element, 'Details', rowsData),
      })
    })
    dispatch(setLoader(false))
    return {
      count: result?.data?.count,
      records: tempData,
    }
  } else {
    dispatch(showAlert([true, result?.message || result?.error?.message, 'error']))
    dispatch(setLoader(false))
    return {
      count: 0,
      records: [],
    }
  }
}

export const fetchPartnerListingForExtraFilter = async () => {
  const requestedData: any = API_CONFIG(
    API_LIST.PARTNER_APIS.GET_ALL_PARTNERS,
    null,
    null,
    'page=1&limit=1000',
  )
  const result: any = await mainApiService(requestedData)
  if (result?.responseCode === 200) {
    const tempData: any = []
    result?.data?.records?.forEach((ele: any) => {
      tempData.push({
        value: ele._id,
        label: ele.serviceName,
      })
    })
    return tempData
  }
}

export const fetchManageTipsListing = async (args: any): Promise<ListAPIDefinationModal> => {
  const { filters, dispatch, setLoader, showAlert, pageConfig } = args

  const payload: any = {
    limit: filters.limit || 10,
    page: filters.pageNumber || 1,
    sortBy: 'module',
    sortType: 1,
  }

  // Add filters dynamically
  if (filters?.filters) {
    payload.filterBy = filters.filters[0]?.filterBy
    ;(payload.filterValue = Array.isArray(filters.filters[0]?.filterValue)
      ? filters.filters[0]?.filterValue.join(',')
      : filters.filters[0]?.filterValue),
      (payload.filterCondition =
        filters.filters[0]?.filterValue.length > 0 ? 'equals' : filters.filters[0]?.filterCondition)
  }

  // Add search filter if provided
  if (filters.search) {
    ;(payload.filterBy = 'module'),
      (payload.filterValue = filters.search),
      (payload.filterCondition = 'contains')
  }

  // Add sorting if provided
  if (filters.sort && filters.sortType) {
    payload.sortBy = filters.sort
    payload.sortType = filters.sortType
  }

  dispatch(setLoader(true))
  const requestedData: any = API_CONFIG(API_LIST.TOOLTIPS.GET)
  const result: any = await mainApiService(requestedData)
  dispatch(setLoader(false))

  if (result?.responseCode === 200) {
    const recordsWithRowURL = result?.data?.records.map((ele: any) => ({
      ...ele,
      rowURL: onClickCommonListingRow({
        key: pageConfig.key,
        row: ele,
      }),
    }))
    dispatch(setLoader(false))
    return { count: result?.data?.count, records: recordsWithRowURL }
  } else {
    dispatch(setLoader(false))
    dispatch(showAlert([true, result?.message || 'Failed to fetch data', 'error']))
    return { count: 0, records: [] }
  }
}

export const fetchModuleOptions = async (): Promise<{ label: string; value: string }[]> => {
  try {
    const requestedData: any = API_CONFIG(API_LIST.TOOLTIPS.GET)
    const result: any = await mainApiService(requestedData)

    if (result?.responseCode === 200) {
      const modules = result?.data?.records?.map((item: any) => ({
        label: item.module,
        value: item.module,
      }))
      // Remove duplicates
      const uniqueModules = Array.from(new Set(modules.map((item: any) => item.value))).map(
        (value) => modules.find((item: any) => item.value === value),
      )
      return uniqueModules
    } else {
      throw new Error(result?.message || result?.error?.message || 'Failed to fetch modules')
    }
  } catch (error) {
    console.error('Error fetching module options:', error)
    return []
  }
}

export const cloneAssetTypeDefinition = async ({
  cloneAsset,
  assetGroupName,
  selectedFilters,
  getListingData,
  dispatch,
  setAssetGroupName,
  setInlineError,
}: any) => {
  const clonePayload = {
    ...cloneAsset,
    isClone: true,
    assetTypeId: cloneAsset._id,
    assetType: assetGroupName.trim(),
  }
  delete clonePayload._id
  delete clonePayload.createdBy
  delete clonePayload.updatedBy

  const response = await dispatch(updateAssetTypeService(clonePayload) as any)

  if (response.payload && !response.payload.error) {
    dispatch(showAlert([true, 'Asset type created successfully', 'success']))
    getListingData(selectedFilters)
    setAssetGroupName('')
    if (setInlineError) {
      setInlineError('')
    }
    return { success: true }
  } else {
    const errorMessage =
      response.payload?.error?.message ||
      response.payload?.error?.errors ||
      'Failed to clone asset definition'

    if (errorMessage === 'Asset Type is already exists in our system') {
      if (setInlineError) {
        setInlineError(
          'This combination of asset type, content category, and asset category already exists.',
        )
      }
      return { success: false, isInlineError: true }
    } else {
      dispatch(showAlert([true, errorMessage, 'error']))
      return { success: false, isInlineError: false }
    }
  }
}
